import * as React from 'react';
import { Translator } from '@cloudflare/intl-core';
export const i18nContext = /*#__PURE__*/React.createContext(new Translator());
export const I18n = i18nContext.Consumer;
export const I18nProvider = i18nContext.Provider;